import {RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import RaikoCategoryManager from "../../component/raikoCategory/RaikoCategoryManager";
import {Box, Typography} from "@material-ui/core";
import * as React from "react";

export default function CostsAndRevenuesCategory() {
    return (
        <RaikoGridOneColumn>
            <Box className="d-flex flex-row w-100"
                 sx={{
                     margin: '1rem 0 1.2rem 0',
                     justifyContent: 'center',
                     alignContent: 'center',
                     alignItems: 'center'
                 }}>
                <section className='d-flex flex-column flex-nowrap flex-grow-1'
                         style={{alignItems: 'start'}}>
                    <Typography variant={"h5"}>
                        دسته بندی ها
                    </Typography>
                </section>
            </Box>
            <RaikoCategoryManager/>
        </RaikoGridOneColumn>
    )
}
